module.exports = __webpack_public_path__ + "static/media/ktm-09.325b8433.jpg";